const COLORS = {
  Low: "#00cc00",
  Medium: "#ff8000",
  High: "#e60000",
};

const GO_KEYS = {
  molecular_function: "Molecular Function",
  biological_process: "Biological Process",
  cellular_component: "Cellular Component",
};

const GENE_DAMAGE_KEYS = {
  primary_immunodeficiency: "Primary Immunodeficiency",
  mendelian: "Mendelian",
  cancer: "Cancer",
};

const TABLE_FIELDS = {
  recessive: ["p_rec", "known_recessive_info"],
  intolerance: ["rvis_evs", "rvis_evs_percentile", "loftool_score"],
  haploinsufficiency: ["p_hi", "hipred_score", "ghis", "hipred"],
  essentials: [
    "essential_gene",
    "essential_crispr",
    "essential_crispr2",
    "essential_mutagenesis",
  ],
  indispensability: ["indispensability_score", "indispensability_pred"],
};

const TABLE_FIELDS_LABELS = {
  p_rec: "P(rec)",
  known_recessive_info: "Known recessive status",
  rvis_evs: "RVIS EVS",
  rvis_evs_percentile: "RVIS EVS percentage",
  loftool_score: "LoFtool Score",
  p_hi: "P(HI)",
  hipred_score: "HIPred score",
  ghis: "GHIS",
  hipred: "HIPred",
  essential_gene: "Essential gene",
  essential_crispr: "Essential gene CRISPR",
  essential_crispr2: "Essential gene CRISPR2",
  essential_mutagenesis: "Essential mutagenesis",
  indispensability_score: "Indispensability score",
  indispensability_pred: "Indispensability prediction",
};

const PATHWAYS = {
  BioCarta: "pathway_biocarta",
  Consensus: "pathway_consensuspathdb",
  UniProt: "pathway_uniprot",
};

const EXPRESSIONS = {
  "GNF/Atlas expression data": "expression_gnf_atlas",
  "Egenetics expression data": "expression_egenetics",
};

export {
  EXPRESSIONS,
  PATHWAYS,
  COLORS,
  GO_KEYS,
  GENE_DAMAGE_KEYS,
  TABLE_FIELDS,
  TABLE_FIELDS_LABELS,
};
